import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useSourcesMenuConfig } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuConfigContextSupport.js';
import { useConnectorDetails } from '#pplx/frontend/apps/ask/connectors/hooks/useConnectorDetails.js';
import { useConnectorStatus } from '#pplx/frontend/apps/ask/connectors/hooks/useConnectorStatus.js';
import { useOpenConnectorModalBySourceId } from '#pplx/frontend/apps/ask/connectors/modal-navigation/useOpenConnectorModalBySourceId.js';
import { getConnectorAvatar } from '#pplx/frontend/apps/ask/files/file-utils/fileUtils.js';
import { usePaywallUpsell } from '#pplx/frontend/apps/ask/hooks/pricing-hooks/usePaywallUpsell.js';
import { useSkillModal } from '#pplx/frontend/apps/ask/skills/hooks/useSkillModal.js';
import { useSourceMeta } from '#pplx/frontend/apps/ask/sources/hooks/useSourceMeta.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React, { useCallback } from 'react';
const ConnectorsEnableModal = Dynamic(async () => {
    const { ConnectorsEnableModal } = await import('#pplx/frontend/apps/ask/connectors/modals/ConnectorsEnableModal.js');
    return { default: ConnectorsEnableModal };
});
export const SourcesMenuItemConnector = React.memo(function SourcesMenuItemConnector({ source, enabled, onToggle, getIsSourceConnected }) {
    const { tagline } = useConnectorDetails(source);
    const openPaywallUpsell = usePaywallUpsell();
    const { hideDescriptionOverlays } = useSourcesMenuConfig();
    const handleOpenPaywall = useCallback(() => {
        openPaywallUpsell({
            origin: ModalOrigin.SOURCES_VIEW_MORE,
        });
    }, [openPaywallUpsell]);
    const content = (_jsx(SourcesMenuItemConnectorContent, { source: source, enabled: enabled, onToggle: onToggle, handleOpenPaywall: handleOpenPaywall, getIsSourceConnected: getIsSourceConnected }));
    if (tagline && !hideDescriptionOverlays) {
        return (_jsx(Tooltip, { content: tagline, side: "right", children: content }));
    }
    return content;
});
const SourcesMenuItemConnectorContent = ({ source, enabled, onToggle, handleOpenPaywall, getIsSourceConnected, }) => {
    const reason = 'sources-menu-item-connector';
    const { getConnectionType } = useConnectorStatus({ reason });
    const { openModal } = useModalContext();
    const openConnectorModal = useOpenConnectorModalBySourceId({
        reason: 'skill-modal-connector',
        openModal,
    });
    const openSkillModal = useSkillModal({ openModal, openConnectorModal });
    const { label, getIcon } = useSourceMeta({ sourceId: source });
    const icon = getIcon('small');
    const isConnected = getIsSourceConnected(source);
    const onSelect = useCallback(() => {
        openModal(ConnectorsEnableModal, {
            connectorName: source,
            connectorAvatar: getConnectorAvatar(source),
            connectionType: getConnectionType(source),
            referrer: 'ask',
            openInNewTab: true,
            reason,
            handleOpenPaywall,
            openSkillModal,
        }, { replace: true });
    }, [openModal, source, reason, getConnectionType, handleOpenPaywall, openSkillModal]);
    if (!isConnected) {
        const arrow = _jsx(Icon, { icon: $icon('arrow-up-right'), size: "small" });
        return (_jsx(DropdownMenu.Item, { leadingAccessory: icon, trailingAccessory: arrow, onSelect: onSelect, children: label }));
    }
    return (_jsx(DropdownMenu.CheckboxItem, { leadingAccessory: icon, checked: enabled, onCheckedChange: onToggle, children: label }));
};
//# sourceMappingURL=SourcesMenuItemConnector.js.map